import React from 'react'
import styles from "./pages.module.scss"
import '../components/pricing/styles.scss';
import BlogCard from '../components/blog/BlogCard';
import Footerhead from '../components/Footerhead';
import FooterCTACard from '../components/FooterCTACard';

const Blog = () => {
  return (

    <div className="pt-4 wholeBody">

      <div className="container sectionHead mt80">
        <div className="row">
          <div className={`align-items-center d-flex flex-column ${styles.sectionheading}`}>
            <h3>Blog</h3>
            <p className='col-md-7'>Bring to the table win-win survival strategies to ensure proactive
              domination. At the end of the day, going forward, a new normal that
              has evolved from generation.</p>
          </div>
        </div>
      </div>

      <BlogCard />

      <FooterCTACard />

      <section className="container ">
        <Footerhead />
      </section>

    </div>
  )
}

export default Blog;